import { tasksForDate, findCategory, workedMin } from "@/lib/store";
import { ISO } from "@/lib/date";

const fmt = (m) => (m >= 60 ? `${Math.floor(m / 60)} h${m % 60 ? ` ${m % 60} min` : ""}` : `${m} min`);

// Weekly time spent per category (timer time, or planned duration of completed activities without timer)
export const WeekTimeByCategory = ({ days, store }) => {
  const totals = new Map();
  for (const d of days) {
    for (const t of tasksForDate(ISO(d))) {
      const m = workedMin(t);
      if (!m) continue;
      const cat = findCategory(t.categoryId) || { id: "?", name: "Senza categoria", color: "#B5B5B5" };
      const cur = totals.get(cat.id) || { cat, min: 0 };
      cur.min += m;
      totals.set(cat.id, cur);
    }
  }
  const rows = [...totals.values()].sort((a, b) => b.min - a.min);
  const all = rows.reduce((s, r) => s + r.min, 0);
  return (
    <div className="tl-paper p-5" data-testid="report-time-by-category" data-store-version={store.tasks.length}>
      <div className="flex items-baseline justify-between gap-3">
        <div className="tl-label">Tempo impiegato per categoria</div>
        <div className="font-serif-display text-2xl text-[#3B443D]" data-testid="report-time-total">{all ? fmt(all) : "—"}</div>
      </div>
      <p className="text-xs text-[#6A7368] mt-1">Dal cronometro; per le attività completate senza cronometro conta la durata prevista.</p>
      {rows.length === 0 ? (
        <div className="mt-3 text-xs italic text-[#6A7368]">Nessun tempo registrato questa settimana.</div>
      ) : (
        <ul className="mt-4 flex flex-col gap-2.5">
          {rows.map(({ cat, min }) => (
            <li key={cat.id} className="flex items-center gap-3" data-testid={`report-time-${cat.id}`}>
              <span className="w-3 h-3 rounded-full flex-shrink-0" style={{ background: cat.color }} />
              <span className="w-32 md:w-40 truncate text-sm text-[#3B443D]">{cat.name}</span>
              <div className="h-2 flex-1 bg-[#F3F5F0] rounded-full overflow-hidden">
                <div className="h-full rounded-full transition-[width] duration-500" style={{ width: `${Math.round((min / all) * 100)}%`, background: cat.color }} />
              </div>
              <span className="tabular-nums text-sm text-[#58635B] w-20 text-right">{fmt(min)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
